// extracted by mini-css-extract-plugin
module.exports = {"Event":"Event_Event__t_osx","spinner":"Event_spinner__rBdFz"};